/* global common */
import { sendAmplitudeEvent, sendRequest } from '@html/_common/utils';

export default function StickyMenu({ selector = '' }) {
  this.common = {};
  if (typeof sendRequest !== 'undefined') {
    this.common = {
      sendRequest,
      sendAmplitudeEvent,
    };
  } else {
    this.common = common;
  }

  const SELECTOR_MENU = `${selector} .js-ao-sticky-menu`;
  const SELECTOR_LIST = `${selector} .js-ao-sticky-menu__sheet-list`;
  const SELECTOR_STICKY_SHEET = `${selector}.js-ao-sticky-menu__sheet`;
  const SELECTOR_CLICKABLE_ELEMENT = ` ${selector}.js-ao-navigation-menu__clickable`;
  const SELECTOR_CONTAINER = `${selector} .js-ao-sticky-menu__sheet-container`;
  const SELECTOR_CLOSE_SHEET = `${selector} .js-ao-sticky-menu__sheet-close`;
  const ACTIVE_CLASS = 'ao-sticky-menu__sheet-list--visible';
  const HIDDEN_CLASS = 'ao-sticky-menu__sheet-container--hidden';
  const CHILDREN_ACTIVE_CLASS = 'ao-sticky-menu__sheet-children-item--visible';
  const SELECTOR_BACK_BUTTON = `${selector} .js-ao-sticky-menu__sheet-back`;
  const SELECTOR_PARENT_ITEM = `${selector} .js-ao-sticky-menu__sheet-list-item`;
  const SELECTOR_OUTSIDE = `${selector} .js-ao-sticky-menu__sheet-outside`;
  let activeParentMenu;
  let scrollOffset;
  const $body = document.querySelector('body');

  const blockBodyScrolling = () => {
    scrollOffset = window.pageYOffset;

    $body.style.overflow = 'hidden';
    $body.style.position = 'fixed';
    $body.style.top = `${-scrollOffset}px`;
    $body.style.touchAction = 'none';
    $body.style.width = '100%';
  };

  const enableBodyScrolling = () => {
    $body.style.removeProperty('position');
    $body.style.removeProperty('overflow');
    $body.style.removeProperty('top');
    $body.style.removeProperty('touch-action');
    $body.style.removeProperty('width');

    window.scrollTo({ top: scrollOffset, behavior: 'instant' });
  };

  const openMenu = (menuId) => {
    activeParentMenu = menuId;
    $(SELECTOR_STICKY_SHEET).removeClass('hid');
    setTimeout(() => $(SELECTOR_CONTAINER).removeClass(HIDDEN_CLASS), 50);
    blockBodyScrolling();
    $(`${SELECTOR_LIST}-${menuId}`).addClass('ao-sticky-menu__sheet-list--visible');
  };

  const closeMenu = () => {
    enableBodyScrolling();
    const parentMenuSelector = `.js-ao-sticky-menu__list-item[data-seo-name="${activeParentMenu}"]`;
    $(SELECTOR_LIST).removeClass('ao-sticky-menu__sheet-list--visible');
    $(SELECTOR_CONTAINER).addClass(HIDDEN_CLASS);
    setTimeout(() => $(SELECTOR_STICKY_SHEET).addClass('hid'), 250);
    $(`.${CHILDREN_ACTIVE_CLASS}`).removeClass(CHILDREN_ACTIVE_CLASS);
    $(SELECTOR_BACK_BUTTON).addClass('hid');
    $(parentMenuSelector).removeClass('ao-sticky-menu__list-item--active');
  };

  this.handleMenuItemClick = (e) => {
    const $currentTarget = $(e?.currentTarget);
    $currentTarget.addClass('ao-sticky-menu__list-item--active');
    openMenu($currentTarget?.data('seo-name'));
  };

  const handleParentClick = (e) => {
    const $currentParent = $(e.currentTarget);
    const currentParentTechnicalName = $currentParent.data('technical-name');
    $currentParent.parent().removeClass(ACTIVE_CLASS);
    $currentParent
      .parent()
      .siblings('.ao-sticky-menu__sheet-children')
      .find(`.js-ao-sticky-menu__sheet-children-item-${currentParentTechnicalName}`)
      .addClass(CHILDREN_ACTIVE_CLASS);
    $(SELECTOR_BACK_BUTTON).removeClass('hid');
  };

  const handleBackButtonClick = () => {
    $(SELECTOR_BACK_BUTTON).addClass('hid');
    $(`.${CHILDREN_ACTIVE_CLASS}`).removeClass(CHILDREN_ACTIVE_CLASS);
    $(`.js-ao-sticky-menu__sheet-list-${activeParentMenu}`).addClass(ACTIVE_CLASS);
  };

  const handleOptionClick = () => {
    $(SELECTOR_CLICKABLE_ELEMENT).on('click', (event) => {
      const eventName = $(SELECTOR_MENU).data('event-name');
      const $currentMenuItem = $(event.currentTarget);
      const optionTitle = $currentMenuItem.data('option-title');
      const menuItemTitle = $currentMenuItem.data('menu-item-title');
      const parent = $currentMenuItem.data('parent-title');

      this.common.sendAmplitudeEvent({
        ampEventName: eventName,
        navigation_menu_option: optionTitle,
        navigation_menu_section: menuItemTitle,
        navigation_submenu_section: parent,
      });
    });
  };

  this.initiate = (e) => {
    this.handleMenuItemClick(e);
    handleOptionClick(e);

    $(SELECTOR_CLOSE_SHEET).on('click', closeMenu);
    $(SELECTOR_PARENT_ITEM).on('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      handleParentClick(event);
    });
    $(SELECTOR_BACK_BUTTON).on('click', handleBackButtonClick);
    $(SELECTOR_OUTSIDE).on('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeMenu();
    });
  };

  this.openStickyMenu = () => {
    openMenu();
  };

  this.closeStickyMenu = () => {
    closeMenu();
  };

  this.initiateWithoutOpening = () => {
    $(SELECTOR_CLOSE_SHEET).on('click', closeMenu);
    $(SELECTOR_PARENT_ITEM).on('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      handleParentClick(event);
    });
    $(SELECTOR_BACK_BUTTON).on('click', handleBackButtonClick);
    $(SELECTOR_OUTSIDE).on('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeMenu();
    });
  };
}
